import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FleetDutyCycleFigureService } from 'src/app/_services/fleet-duty-cycle-figure.service';
import { VehicleDutyCycleInsightsService } from 'src/app/_services/vehicle-duty-cycle-insights.service';
import { LoadingEntity} from '@inst-iot/bosch-angular-ui-components';
import { sortRbTableData } from 'src/app/_shared/utils/sort-utils';

@Component({
  selector: 'app-temperature-vehicles',
  templateUrl: './temperature-vehicles.component.html',
  styleUrls: ['./temperature-vehicles.component.scss']
})
export class TemperatureVehiclesComponent implements OnChanges, OnDestroy {
  private readonly unsubscribe$ = new Subject<void>();
  @Input() compareToFleet!: boolean;
  @Input() selectedVehicles: any;
  @Input() fleetId: string[] = [];
  @Input() companyData: any;
  @Input() isMetric: boolean | undefined;
  currentVehicleData: any;
  deviceSerialNumber!: any[];
  deviceDataArray: any;
  vehiclesTempInsights: any;
  errorMessage: boolean = false;
  dataLoading: boolean = false;
  timeSpentExtremeTemperatureDatapoints: any;
  loader = new LoadingEntity;
  readonly sortData = sortRbTableData;

  constructor(
    private readonly vehicleDutyCycleInsightsService: VehicleDutyCycleInsightsService,
    private readonly fleetDutyCycleFigureService: FleetDutyCycleFigureService,
  ) {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.deviceSerialNumber = this.selectedVehicles.map((vehicle: { batteryIdentifier: any; }) => vehicle.batteryIdentifier);
    this.vehicleDutyCycleInsightsService.getCurrentTempInsights(this.deviceSerialNumber).pipe(takeUntil(this.unsubscribe$)).subscribe(
      {
        next: (data: any) => {
          Object.keys(data).forEach((deviceSerialNumberId: string) => {
            this.deviceDataArray = data[deviceSerialNumberId];
            this.vehiclesTempInsights=data;
            this.currentVehicleData = this.selectedVehicles.map((vehicle: { batteryIdentifier: string; name: string; batteryId: string }) => ({
              ...data[vehicle.batteryIdentifier],
              vehicleName: vehicle.name,
              batteryId: vehicle.batteryId
            }));
          })
        },
      }
    )

    this.dataLoading = true;
    this.errorMessage = false;
    this.fleetDutyCycleFigureService.getTimeSpentExtremeTemperatureFleet(this.fleetId).pipe(takeUntil(this.unsubscribe$)).subscribe(
      {
        next: (datapoints) => {
          this.timeSpentExtremeTemperatureDatapoints = datapoints;
        },
        error: (error) => {
          console.error('Error fetching Time Spent Charging in Extreme Temperature Fleet data:', error);
          this.dataLoading = false;
          this.errorMessage = true;
        },
        complete: () => {
          this.dataLoading = false;
        }
      }
    )
  }
}
